import { ViteSSG } from "vite-ssg";

import App from "@/App.vue";
import { routes } from "@/routes";
import "@/styles.css";

export const createApp = ViteSSG(App, {
  routes,
  scrollBehavior: (to) =>
    // Honour a hash. Always returning the top meant an in-page anchor scrolled
    // nowhere, so a link to a section on the current page did nothing at all.
    to.hash ? { el: to.hash, behavior: "smooth" } : { left: 0, top: 0 },
});
